import { useContext, useState, useEffect } from 'react';

import LoadingSpinner from '../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../shared/context/auth-context';
import { useHttpClient } from '../shared/hooks/http-hook';
import { Invite } from './profileFnF/Invite';
import { ProfileSettings } from './profileSettings/ProfileSettings';
import { ProfileStats } from './profileStats/ProfileStats';
import { navigation, NavigationItem } from './profileTabNavigation/navigation';
import { ProfileTabNavigation } from './profileTabNavigation/ProfileTabNavigation';
import './styles/Profile.css';

const MOBILE_WIDTH = 1240;

export function Profile() {
  const { isLoading } = useHttpClient();
  const auth = useContext(AuthContext);
  const [activePage, setActivePage] = useState<NavigationItem | undefined>();
  const [isHidden, setIsHidden] = useState(window.innerWidth < MOBILE_WIDTH);

  useEffect(() => {
    const handleResize = () => setIsHidden(window.innerWidth < MOBILE_WIDTH);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!activePage) {
      setActivePage(
        navigation.find((item) => item.title === window.location.pathname.split('/')[2])
      );
    }
  }, [activePage]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  const renderPageContent = () => {
    if (!activePage) return null;

    switch (activePage?.target) {
      case navigation[0].target:
        return <ProfileSettings isHidden={isHidden} />;
      case navigation[1].target:
        return <ProfileStats hide={isHidden} />;
      case navigation[2].target:
        return <Invite hide={isHidden} />;
      default:
        return null;
    }
  };

  return (
    <div id="main_container" className="foryou health-area platform glowrm">
      {isLoading && <LoadingSpinner asOverlay />}
      {auth.isLoggedIn && (
        <>
          <ProfileTabNavigation activePage={activePage} setActivePage={setActivePage} />
          <main className="page-container">{renderPageContent()}</main>
        </>
      )}
    </div>
  );
}
